import Button from 'components/commercetools-ui/atoms/button';
import Image, { ImageProps } from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import useClassNames from 'helpers/hooks/useClassNames';
import { Reference } from 'types/reference';

export interface TileProps {
  image?: ImageProps;
  title: string;
  subtitle: string;
  ctaLabel?: string;
  ctaReference?: Reference;
  roundedBorders?: boolean;
  className?: string;
}

const Tile: React.FC<TileProps> = ({
  image,
  title,
  subtitle,
  ctaLabel,
  ctaReference,
  roundedBorders = true,
  className = '',
}) => {
  const imageClassName = useClassNames([{ 'rounded-xl': roundedBorders }]);

  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      {image ? (
        <>
          <Image {...image} alt={title} style={{ objectFit: 'cover' }} className={`brightness-90 ${imageClassName}`} />
          <div className="absolute inset-x-0 bottom-0 flex w-full flex-col items-start px-20 pb-20 pt-40">
            <h2 className="text-shadow text-26 font-bold text-white md:text-28">{title}</h2>
            {ctaLabel && (
              <div className="mt-16">
                <Link link={ctaReference}>
                  <Button variant="ghost" className="rounded-xl bg-white px-28 py-10">
                    <span className="text-12 font-semibold uppercase tracking-wide text-black">{ctaLabel}</span>
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </>
      ) : (
        <div
          className={`flex h-full flex-col items-center justify-center rounded-xl bg-black px-24 py-32 text-center text-white`}
        >
          <h2 className="text-24 font-bold leading-[32px] md:text-28 md:leading-tight">{title}</h2>
          {subtitle && (
            <p className="mt-12 max-w-xl text-14 font-medium leading-[22px] opacity-90 md:text-16">{subtitle}</p>
          )}
          {ctaLabel && (
            <div className="mt-24">
              <Link link={ctaReference}>
                <Button variant="ghost" className="rounded-xl bg-white px-38 py-10">
                  <span className="text-12 font-semibold uppercase tracking-wide text-black">{ctaLabel}</span>
                </Button>
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Tile;
